import React, { useState, useRef, useEffect } from "react";
import _ from "lodash";
import Gsk from "~/images/GSK.png";
import Pfizer from "~/images/Pfizer.png";
import NovoNordisk from "~/images/NovoNordisk.png";
import Sandoz from "~/images/Sandoz.png";
import Sumitomo from "~/images/Sumitomo.png";

const SelectManufacturers = (props) => {
  const renderCheck = (manufacturer) => {
    if (props.selectedManufacturer == manufacturer) {
      return (
        <div className={"selector__option__radio selector__option__radio--selected"}>
          <i className="solid solid-budicon-check-ui"></i>
        </div>
      );
    } else {
      return <div className={"selector__option__radio"}></div>;
    }
  };

  const handleSelect = (manufacturer) => {
    if (manufacturer != props.selectedManufacturer) {
      props.setSelectedManufacturer(manufacturer);
    } else {
      props.setSelectedManufacturer(null);
    }
  };

  const renderOptions = () => {
    return (
      <div className="selector__container">
        <div
          className={
            props.selectedManufacturer == "glaxosmithkline"
              ? "selector__option selector__option--selected"
              : "selector__option"
          }
          onClick={() => handleSelect("glaxosmithkline")}
        >
          <div className="selector__option__group">
            <div className="selector__option__logo">
              <img src={Gsk} />
            </div>
            <div className="selector__option__container">
              <div className="selector__option__container__title">GlaxoSmithKline</div>
              <div className="selector__option__container__subtitle">Wholly Owned Exemption</div>
            </div>
          </div>
          {renderCheck("glaxosmithkline")}
        </div>
        <div
          className={
            props.selectedManufacturer == "novo_nordisk"
              ? "selector__option selector__option--selected"
              : "selector__option"
          }
          onClick={() => handleSelect("novo_nordisk")}
        >
          <div className="selector__option__group">
            <div className="selector__option__logo">
              <img src={NovoNordisk} />
            </div>
            <div className="selector__option__container">
              <div className="selector__option__container__title">Novo Nordisk</div>
              <div className="selector__option__container__subtitle">Wholly Owned Exemption</div>
            </div>
          </div>
          {renderCheck("novo_nordisk")}
        </div>
        <div
          className={
            props.selectedManufacturer == "sandoz" ? "selector__option selector__option--selected" : "selector__option"
          }
          onClick={() => handleSelect("sandoz")}
        >
          <div className="selector__option__group">
            <div className="selector__option__logo">
              <img src={Sandoz} />
            </div>
            <div className="selector__option__container">
              <div className="selector__option__container__title">Sandoz</div>
              <div className="selector__option__container__subtitle">Wholly Owned Exemption</div>
            </div>
          </div>
          {renderCheck("sandoz")}
        </div>
        <div
          className={
            props.selectedManufacturer == "sumitomo"
              ? "selector__option selector__option--selected"
              : "selector__option"
          }
          onClick={() => handleSelect("sumitomo")}
        >
          <div className="selector__option__group">
            <div className="selector__option__logo">
              <img src={Sumitomo} />
            </div>
            <div className="selector__option__container">
              <div className="selector__option__container__title">Sumitomo</div>
              <div className="selector__option__container__subtitle">Wholly Owned Exemption</div>
            </div>
          </div>
          {renderCheck("sumitomo")}
        </div>
        <div
          className={
            props.selectedManufacturer == "pfizer" ? "selector__option selector__option--selected" : "selector__option"
          }
          onClick={() => handleSelect("pfizer")}
        >
          <div className="selector__option__group">
            <div className="selector__option__logo">
              <img src={Pfizer} />
            </div>
            <div className="selector__option__container">
              <div className="selector__option__container__title">Pfizer</div>
              <div className="selector__option__container__subtitle">Wholly Owned Exemption</div>
            </div>
          </div>
          {renderCheck("pfizer")}
        </div>
      </div>
    );
  };

  return renderOptions();
};

export default SelectManufacturers;
